import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import SurveyVote from "./SurveyVote";
import Modal from "../Modal";
import {Button} from "../Button";
import Icon from "../Icon";
import {PageLoader} from "../Loader";
import {apiUrl} from "../../../libs/api";


class Survey extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleVote: false,
            voteLimit: 5,
            survey : this.props.fakeSurvey || {},
            error: false,
        };

        if(this.props.survey && this.props.survey._id){
            if(this.props.forumId && this.props.topicId && this.props._id && isNaN(this.props._id)){
                apiUrl.get(`/forums/${this.props.forumId}/topics/${this.props.topicId}/comments/${this.props._id}`).then(survey => {
                    if(survey === null){
                        this.setState({error: true})
                    } else {
                        this.setState({survey});
                    }
                }).catch(e => {
                    this.setState({error: true})
                });
            }
        }
    }

    componentDidMount() {
        if(this.props.survey && this.props.survey._id){
            this.setState({survey: this.props.survey});
        }
    }

    render() {
        return !this.props.surveyInitialized ? (
            <div className={"survey"}>
                <PageLoader />
            </div>
        ) : this.state.survey && this.state.survey.choices && this.state.survey.choices.length >= 1 ? (
            <div className={"survey"}>
                <div className={"survey-topline"}>
                    <div className={"survey-title"}>Sondage</div>
                    <div className={"survey-name"}>{this.state.survey.name}</div>
                </div>
                <div className={"survey-body"}>
                    {this.state.survey.choices.sort(function (a, b) {return b.total - a.total;}).slice(0, this.state.voteLimit).map((vote, index) => (
                        <div className={"survey-vote"} key={index}>
                            <div className={"survey-vote-infos"}>
                                <span className={"survey-vote-name"}>{vote.name}</span>
                                <span className={"survey-vote-stat"}>{vote.count} vote{vote.total > 1 ? 's' : ''} {vote.isVoted && <Icon type={"check-circle"} />}</span>
                            </div>
                            <div className={"survey-bar-container"}>
                                <div className={"survey-bar-progression"} style={{width: `${vote.count / this.state.survey.total * 100}%`}} />
                            </div>
                        </div>
                    ))}
                    {this.state.survey.choices.length > 5 && this.state.voteLimit <= 5 && (
                        <span className={"survey-more-options"} onClick={()=>this.setState({voteLimit: 20})}>
                            Afficher plus d'options
                        </span>
                    )}
                </div>
                {!this.props.fakeSurvey && (
                    <Fragment>
                        <div className={"survey-baseline"}>
                            <Button btnStyle={"primary-reverse"}
                                    size={"small"}
                                    onClick={()=> this.setState({toggleVote: true})}
                                    content={this.state.survey.hasVoted ? "Modifier le vote" : "Voter"}/>
                        </div>
                        <Modal toggle={this.state.toggleVote} handleClose={()=>this.setState({toggleVote: false})}>
                            <SurveyVote _id={this.props.survey._id}
                                        handleClose={()=>this.setState({toggleVote: false})}/>
                        </Modal>
                    </Fragment>
                )}
            </div>
        ) : null;
    }
}

const mapStateToProps = (state) => {
    return {
        survey: [],
        surveyLoading: false,
        surveyInitialized: true,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Survey);